<template>
  <div class="lectoras" style="background-color:#ffffff; border-radius: 20px;">

    <vue-element-loading :active="cargando" spinner="bar-fade-scale" color="#064dc3" size="120" :is-full-screen="true" text="Cargando..."/>
    <div class="form-row">
      <h1 class="col-8">Reporte de Lectoras Datos</h1>
      <div class="col-3"></div>
      <router-link to="/home">
        <b-button variant="outline-success" style="margin: 10px">
          <div class="h6 mb-1">
            <b-icon-arrow-left-square></b-icon-arrow-left-square>
          </div>
          <div style="font-size: 12px;">
            Inicio
          </div>
        </b-button>
      </router-link>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="col-form-label">Unidades</label>
        <multiselect ref="select" v-model="dispositivosSeleccionados" placeholder="Seleccione los dispositivos" label="name" track-by="id" :options="dispositivosObtenidos" :multiple="true" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover">
        </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAll">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAll">Limpiar</button>
      </div>
      <div class="col-12">
        <label class="col-form-label">Grupos</label>
        <multiselect ref="select" v-model="gruposSeleccionados" placeholder="Seleccione los dispositivos" label="name" track-by="id" :options="gruposObtenidos" :multiple="true" :hide-selected="true" select-label="Seleccionar" deselect-label="Remover">
        </multiselect>
        <button class="btn btn-sm btn-outline-primary mt-1" @click="selectAllGrupos">Select todo</button>
        <button class="btn btn-sm btn-outline-primary mt-1 ml-2" @click="removeAllGrupos">Limpiar</button>
      </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaInicio">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaInicio">
      </div>
      <div class="col-md-4 mt-4">
        <input type="date" class="form-control" v-model="fechaFin">
      </div>
      <div class="col-md-2 mt-4">
        <input type="time" class="form-control" v-model="horaFin">
      </div>
    </div>
    <button class="btn btn-sm btn-primary mt-3" @click="generarReporte()">Generar reporte</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportExcel()">Exportar Excel</button>
    <button class="btn btn-sm btn-primary mt-3 ml-2" @click="exportCSV()">Exportar CSV</button>
    <div class="table-responsive mt-4">
      <table  class="table table-bordered table-hover text-center">
        <thead style="background-color: #05123C;">
          <tr class="text-white">
            <th>Unidad</th>
            <th>No.Empleado</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody v-for="item of formatearDatos" >  
        <tr>
            <td>{{ item.Unidad }}</td>
            <td bgcolor="red" v-if="item.Type=='Apagado' && item.NoEmpleado==''" >{{item.Type}}</td> 
            <td bgcolor="green" v-else-if="item.Type=='Encendido' && item.NoEmpleado==''" >{{item.Type}}</td> 
            <td v-else>{{item.NoEmpleado}}</td>  
            <td>{{item.Fecha}}</td>           
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>

import { mapState, mapMutations, mapActions } from "vuex";


export default {
  data() {
    return {
      dispositivosObtenidos: [],
      dispositivosSeleccionados: [],
      dispositivosSeleccionados2: [],
      gruposObtenidos: [],
      gruposSeleccionados: [],
      gruposSeleccionados2: [],
      fechaInicio: '',
      horaInicio: '00:00',
      fechaFin: '',
      horaFin: '00:00',
      datosReporte: []
    }
  },
  watch: {
    dispositivosSeleccionados(newSelected) {
  
     
      this.dispositivosSeleccionados = newSelected;
      
    },
    gruposSeleccionados(newSelected) {
  
     
  this.gruposSeleccionados = newSelected;
 
}
  },

  computed: {
    ...mapState({
      catUnidades: state => state.catalogos.catUnidades
    }),

    ...mapState(["cargando"]),
    formatearIds() {
      //let data = '';
      var index = 0;
      this.dispositivosSeleccionados2 = [];
      for (let item of this.dispositivosSeleccionados) {
        //(index == 0) ? data += 'deviceId=' + item.id : data += '&deviceId=' + item.id;
        this.dispositivosSeleccionados2.push(item.id);
        index++;
      }
      return this.dispositivosSeleccionados2;
    },


    formatearIdGrupo() {
       var index = 0;
       this.gruposSeleccionados2= [];
      for (let item of this.gruposSeleccionados) {
        this.gruposSeleccionados2.push(item.id);
        index++;
      }
      return this.gruposSeleccionados2;
    },

     formatearDatos() {
        var index = 0;
      for (let item of this.datosReporte) {
        item.segundos = '';
        index++;
      }
     return this.datosReporte;
                       
      
    }
  },

  methods: {
    ...mapActions("catalogos", ["obtenerUnidades"]),
    ...mapMutations(["setearCargando"]),

    obtenerSesion() {
      let params = new URLSearchParams();
      params.append("email", "desarrollo.gps@busmen.com");
      params.append("password", "12345");
      let headers = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };

      axios.post(`${url}session`, params, JSON.parse(localStorage.user))
        .then(response => {
          console.log("Sesion");
        })
        .catch(error => {
          console.log("No sesion");
        });
    },

    generarReporte() {
      if ((this.fechaInicio !='' & this.fechaFin.length !='')&(this.gruposSeleccionados != '' || this.dispositivosSeleccionados != '')) {
        let fechaInicio = encodeURIComponent( new Date(this.fechaInicio + ' ' + this.horaInicio).toISOString() );
        let fechaFin = encodeURIComponent( new Date(this.fechaFin + ' ' + this.horaFin).toISOString());

        this.setearCargando(true);
        this.reporteLectoras(fechaInicio, fechaFin);
      }
      else if (this.fechaInicio =='' & this.fechaFin.length =='' & this.gruposSeleccionados == '' & this.dispositivosSeleccionados == '')
      {
        alert('Debe seleccionar las fechas y unidades');
      }
      
      else if (this.fechaInicio ==''  & this.fechaFin.length =='' & this.gruposSeleccionados != '' || this.dispositivosSeleccionados != '' & this.fechaInicio ==''  & this.fechaFin.length =='')
      {
        alert('Debe seleccionar las fechas');
      }
      
      else if (this.fechaInicio !='' & this.fechaFin.length !='' & this.gruposSeleccionados == '' ||  this.fechaInicio !='' & this.fechaFin.length !='' & this.dispositivosSeleccionados == '')
      {
        alert('Debe seleccionar las unidades');
      }
    }, 
     reporteLectoras(fechaInicio, fechaFin){
      axios.post(`${url2}eventoslectorasdatos`,{
        'deviceid' : this.formatearIds,'groupid' : this.formatearIdGrupo,'FechaInicio' : this.fechaInicio + ' ' + this.horaInicio, 'FechaFin' : this.fechaFin + ' ' + this.horaFin }, {
        headers: {'content-type' : 'application/json'}})
      .then(response => {
          this.datosReporte = response.data.datos;
         // this.removeAll();
          this.setearCargando(false); 
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },
    
     reporteLectorasGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/events?${this.formatearIdGrupo}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          alert('Ha ocurrido un error');
          this.setearCargando(false);
        });
    },

    reporteGrupos(fechaInicio, fechaFin){
      axios.get(`${url}reports/summary?${this.formatearIdGrupo}&from=${fechaInicio}&to=${fechaFin}` , JSON.parse(localStorage.user))
        .then(response => {
          this.datosReporte = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

    selectAll() {
      this.dispositivosSeleccionados = [];
      for (let item of this.dispositivosObtenidos) {
          this.dispositivosSeleccionados.push(item);
      }
    },
    
     selectAllGrupos() {
      this.gruposSeleccionados = [];
      for (let item of this.gruposObtenidos) {
          this.gruposSeleccionados.push(item);
      }
    },

    removeAll() {
      this.dispositivosSeleccionados = [];
      this.dispositivosSeleccionados2 = [];
      this.gruposSeleccionados = [];
      this.gruposSeleccionados2 = [];  
    },
    
    removeAllGrupos() {
      this.gruposSeleccionados = [];
    },

    exportExcel() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte, { header: ['Unidad', 'NoEmpleado', 'Fecha'] } );
        data['A1'].v = 'Unidad';
        data['B1'].v = 'NoEmpleado';
        data['C1'].v = 'Fecha';
        data['D1'].v = '';
       

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
       // XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },
    exportCSV() {
			if(this.datosReporte){
        let data = XLSX.utils.json_to_sheet(this.datosReporte, { header: ['Unidad', 'NoEmpleado', 'Fecha'] } );
        data['A1'].v = 'Unidad';
        data['B1'].v = 'NoEmpleado';
        data['C1'].v = 'Fecha';
        data['D1'].v = '';
       

				const workbook = XLSX.utils.book_new();
				const filename = 'Reporte';
				XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.csv`);
       // XLSX.writeFile(workbook, `${filename}${this.fechaInicio} ${this.horaInicio} - ${this.fechaFin} ${this.horaFin}.xlsx`);
			}
			else{
				alert('Ha ocurrido un error');
      }
    },

    obtenerDispositivos() {
      this.setearCargando(true);
      axios.get(`${url}devices`, JSON.parse(localStorage.user))
        .then(response => {
          this.dispositivosObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');
        });
    },

    obtenerGrupos() {
      this.setearCargando(true);
      axios.get(`${url}groups`, JSON.parse(localStorage.user))
        .then(response => {
          this.gruposObtenidos = response.data;
          this.setearCargando(false);
        })
        .catch(error => {
          this.setearCargando(false);
          alert('Ha ocurrido un error');

        });
    },
  },

  created() {
    this.obtenerDispositivos();
    this.obtenerGrupos();
  },

  mounted() {
    if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
  }
  }
}
</script>
<style>
  .lectoras{
    margin: 50px;
    margin-bottom:1%;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
    padding-top:15px;
  }
</style>